import { BankOperationStatusesNew } from 'constants/bankOperationStatusesNew';

import { styled } from '@mui/material/styles';
import { ChipField } from 'react-admin';
import { Box } from 'shared/mui/Box';

import { STATUS_COLORS } from './constants/statusColors';

export const ChipFieldWrapperStyled = styled(Box)({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '5px',
  height: 'auto',
  alignItems: 'center',
});

export const ChipFieldStyled = styled(ChipField)({
  margin: '0 !important',
  height: '24px',
  minWidth: 0,
});

export const StatusIconStyled = styled('div')<{ status?: BankOperationStatusesNew }>(
  ({ status }) => ({
    height: '16px',
    width: '16px',
    flexShrink: 0,
    backgroundColor: status
      ? STATUS_COLORS[status as BankOperationStatusesNew]
      : STATUS_COLORS['default'],
    borderRadius: '100%',
  }),
);
